import {Component, EventEmitter,ViewEncapsulation,Input,Output  } from '@angular/core';

@Component({
  selector: 'ngbd-modal-customclasssection',
  templateUrl: './modal-customclasssection.html'
})
export class NgbdModalCustomclasssection {
	@Input() activeFieldSectionType;
	@Input() fieldTabArray;
	@Output() AddMoreOptionsFInsideTab = new EventEmitter();
	@Output() AddOptionsFieldInsideSections = new EventEmitter();
	@Output() close_section_field = new EventEmitter();
  constructor() {
	
  }
  
  AddMoreOptionsFInside(h){
	this.AddMoreOptionsFInsideTab.emit(h);
  }
  AddOptionsFieldInsideSection(){
	this.AddOptionsFieldInsideSections.emit();
  } 
  close_pop(){
	this.close_section_field.emit();
  }
}



// WEBPACK FOOTER //
// ./src/app/system_setting/DFB/template/create/modal-customclasssection.ts